module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_garten_3.cfa2494e.jpg";